import script from "./zhIconDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./zhIconDialog.vue?vue&type=script&setup=true&lang=js"

import "./zhIconDialog.vue?vue&type=style&index=0&id=6260d019&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\zh-frontend\\microfront-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6260d019"]])

export default __exports__